export enum DialogsName {
  AccountForm = 'account-form',
  CurrencyForm = 'currency-form',
  InviteForm = 'invite-user',
  UserForm = 'user-form',
  ExchangeRateForm = 'exchangeRate-form',
  ItemCategoryForm = 'item-category-form',
  InventoryAdjustmentForm = 'inventory-adjustment',
  PaymentViaVoucherForm = 'payment-via-voucher',
  KeyboardShortcutForm = 'keyboard-shortcuts',
  ContactDuplicateForm = 'contact-duplicate',
  QuickPaymentReceiveForm = 'quick-payment-receive',
  QuickPaymentMadeForm = 'quick-payment-made',
  AllocateLandedCostForm = 'allocate-landed-cost',
  InvoicePdfForm = 'invoice-pdf-preview',
  EstimatePdfForm = 'estimate-pdf-preview',
  ReceiptPdfForm = 'receipt-pdf-preview',
  CreditNotePdfForm = 'credit-note-pdf-preview',
  PaymentPdfForm = 'payment-pdf-preview',
  MoneyInForm = 'money-in',
  MoneyOutForm = 'money-out',
  NotifyInvoiceViaForm = 'notify-invoice-via-sms',
  NotifyReceiptViaForm = 'notify-receipt-via-sms',
  NotifyEstimateViaForm = 'notify-estimate-via-sms',
  NotifyPaymentViaForm = 'notify-payment-via-sms',
  BadDebtForm = 'write-off-bad-debt',
  SMSMessageForm = 'sms-message-form',
  RefundCreditNote = 'refund-credit-note',
  RefundVendorCredit = 'refund-vendor-credit',
  ReconcileCreditNote = 'reconcile-credit-note',
  ReconcileVendorCredit = 'reconcile-vendor-credit',
  WarehouseForm = 'warehouse-form',
  BranchForm = 'branch-form',
  BranchActivateForm = 'branch-activate',
  BranchMergeForm = 'branch-merge',
  WarehouseActivateForm = 'warehouse-activate',
  CustomerOpeningBalanceForm = 'customer-opening-balance',
  VendorOpeningBalanceForm = 'vendor-opening-balance',
  ProjectForm = 'project-form',
  ProjectTaskForm = 'project-task-form',
  ProjectTimeEntryForm = 'project-time-entry-form',
  ProjectExpenseForm = 'project-expense-form',
  EstimateExpenseForm = 'estimate-expense-form',
  ProjectInvoicingForm = 'project-invoicing-form',
  ProjectBillableEntriesForm = 'project-billable-entries',
  InvoiceNumberSettings = 'InvoiceNumberSettings',
  TaxRateForm = 'tax-rate-form',
  PayrollRunForm = 'payroll-run-form',
  InvoiceExchangeRateChangeNotice = 'InvoiceExchangeRateChangeNotice',
  InvoiceBulkDelete = 'invoices-bulk-delete',
  EstimateBulkDelete = 'estimates-bulk-delete',
  ReceiptBulkDelete = 'receipts-bulk-delete',
  CreditNoteBulkDelete = 'credit-notes-bulk-delete',
  PaymentReceivedBulkDelete = 'payments-received-bulk-delete',
  BillBulkDelete = 'bills-bulk-delete',
  VendorCreditBulkDelete = 'vendor-credits-bulk-delete',
  ManualJournalBulkDelete = 'manual-journals-bulk-delete',
  ExpenseBulkDelete = 'expenses-bulk-delete',
  AccountBulkDelete = 'accounts-bulk-delete',
  ItemBulkDelete = 'items-bulk-delete',
  ItemCategoryBulkDelete = 'item-categories-bulk-delete',
  CustomerBulkDelete = 'customers-bulk-delete',
  VendorBulkDelete = 'vendors-bulk-delete',
  GenericBulkDelete = 'generic-bulk-delete',
  InvoiceMail = 'invoice-mail',
  EstimateMail = 'estimate-mail',
  ReceiptMail = 'receipt-mail',
  PaymentMail = 'payment-mail',
  ConnectBankCreditCard = 'connect-bank-credit-card',
  InvoiceFormMailDeliver = 'InvoiceFormMailDeliver',
  EstimateFormMailDeliver = 'EstimateFormMailDeliver',
  ReceiptFormMailDeliver = 'ReceiptFormMailDeliver',
  BalanceSheetPdfPreview = 'BalanceSheetPdfPreview',
  TrialBalanceSheetPdfPreview = 'TrialBalanceSheetPdfPreview',
  CashflowSheetPdfPreview = 'CashflowSheetPdfPreview',
  ProfitLossSheetPdfPreview = 'ProfitLossSheetPdfPreview',
  InventoryValuationPdfPreview = 'InventoryValuationPdfPreview',
  APAgingSummaryPdfPreview = 'APAgingSummaryPdfPreview',
  ARAgingSummaryPdfPreview = 'ARAgingSummaryPdfPreview',
  JournalPdfPreview = 'JournalPdfPreview',
  SalesByItemsPdfPreview = 'SalesByItemsPdfPreview',
  PurchasesByItemsPdfPreview = 'PurchasesByItemsPdfPreview',
  VendorBalancePdfPreview = 'VendorBalancePdfPreview',
  InventoryItemDetailsPdfPreview = 'InventoryItemDetailsPdfPreview',
  CustomerBalanceSummaryPdfPreview = 'CustomerBalanceSummaryPdfPreview',
  CustomerTransactionsPdfPreview = 'CustomerTransactionsPdfPreview',
  VendorTransactionsPdfPreview = 'VendorTransactionsPdfPreview',
  GeneralLedgerPdfPreview = 'GeneralLedgerPdfPreview',
  SalesTaxLiabilitySummaryPdfPreview = 'SalesTaxLiabilitySummaryPdfPreview',
  GenericPdfPreview = 'GenericPdfPreview',
  Export = 'Export',
  BankRuleForm = 'BankRuleForm',
  DisconnectBankAccountConfirmation = 'DisconnectBankAccountConfirmation',
  SharePaymentLink = 'SharePaymentLink',
  SelectPaymentMethod = 'SelectPaymentMethodsDialog',

  StripeSetup = 'StripeSetup',
  PayzoneSetup = 'PayzoneSetup',
  ApiKeysGenerate = 'api-keys-generate',
  GenericNumberSettings = 'GenericNumberSettings',
  GenericSendMessage = 'GenericSendMessage'
}
